import { Inline } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { useTranslation } from "react-i18next";

import css from "./status.module.scss";

interface StatusProps {
  isPrivate?: boolean;
  isDraft?: boolean;
}

export const Status = ({ isPrivate, isDraft }: StatusProps) => {
  const { t } = useTranslation();
  return (
    <div className={css.wrapper}>
      {isPrivate && (
        <Inline className={css.tag}>
          <Icon name="hidden" />
          {t("privatePrivacy")}
        </Inline>
      )}
      {isDraft && (
        <Inline className={css.tag}>
          <Icon name="edit" />
          {t("draft")}
        </Inline>
      )}
    </div>
  );
};
